import React from "react";
import { Col, ColProps, Row, Tooltip, TooltipProps } from "antd";
import { combineClasses } from "../../../lib/utils";
import { CustomOmit } from "../../../lib/types/utilityTypes/CustomOmit";
import "./DataItem.less";

interface ComponentProps {
  className?: string;
  label: string;
  value: any;
  wraperColProps?: ColProps;
  labelColProps?: ColProps;
  valueColProps?: ColProps;
  displayTitle?: boolean;
  tooltipTitle?: TooltipProps["title"];
  tooltipProps?: CustomOmit<TooltipProps, "overlay" | "title">;
}

/**
 * Отображение данных вида label: value. Необходимо размещать внутри элемента Row
 */

export const DataItem = (props: ComponentProps) => {
  const {
    className,
    label,
    value = "",
    wraperColProps = {},
    labelColProps = {},
    valueColProps = {},
    tooltipTitle = "",
    tooltipProps = {},
  } = props;

  return (
    <Col className={combineClasses("data-item", className)} {...wraperColProps}>
      <Row>
        <Col {...labelColProps}>
          <div className="data-item__label">{label}:</div>
        </Col>
        <Col {...valueColProps}>
          <Tooltip title={tooltipTitle} {...tooltipProps}>
            <div className="data-item__value">{value}</div>
          </Tooltip>
        </Col>
      </Row>
    </Col>
  );
};
